"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _utils = require("../../../common/utils");
var _paymentMethodTypes = require("../../payment-method-types");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PpsdkPayloadMapper = exports.default = /*#__PURE__*/function () {
  function PpsdkPayloadMapper() {
    _classCallCheck(this, PpsdkPayloadMapper);
  }
  return _createClass(PpsdkPayloadMapper, [{
    key: "mapToPayload",
    value:
    /**
     * @param {PaymentRequestData} data
     * @returns {Object}
     */
    function mapToPayload(data) {
      var additionalAction = data.additionalAction,
        _data$payment = data.payment,
        payment = _data$payment === void 0 ? {} : _data$payment,
        paymentMethod = data.paymentMethod;
      return (0, _utils.omitNil)({
        instrument: {
          expires: {
            month: payment.ccExpiry ? (0, _utils.toNumber)(payment.ccExpiry.month) : null,
            year: payment.ccExpiry ? (0, _utils.toNumber)(payment.ccExpiry.year) : null
          },
          name: payment.ccName,
          number: payment.ccNumber,
          verification_value: payment.ccCvv,
          type: _paymentMethodTypes.PPSDK_CREDIT_CARD
        },
        form_nonce: payment.hostedFormNonce,
        payment_method_id: paymentMethod.id,
        human_verification: additionalAction ? {
          id: 'recaptcha_v2_verification',
          parameters: {
            token: additionalAction ? additionalAction.data.human_verification_token : null
          }
        } : null
      });
    }

    /**
     * @param {PaymentRequestData} data
     * @returns {Object}
     */
  }, {
    key: "mapToHeaders",
    value: function mapToHeaders(data) {
      var authToken = data.authToken;
      return (0, _utils.omitNil)({
        Authorization: authToken
      });
    }
  }], [{
    key: "create",
    value:
    /**
     * @returns {PayloadMapper}
     */
    function create() {
      return new PpsdkPayloadMapper();
    }
  }]);
}();
//# sourceMappingURL=ppsdk-payload-mapper.js.map